// import AuthMiddleware from "../middleware/authMiddleware";

const get_token = () => {
  return new Promise((resolve, rej) => {
    let user = JSON.parse(localStorage.getItem("myData"));
    if (user) {
      return resolve(user.access_token);
    }
    else {
      // AuthMiddleware.logOut();
      rej("session-expired");
    }
  });
};

const utils = {
  get_token
};

export default utils;
